'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GreaterThan = function () {
  function GreaterThan() {
    'ngInject';

    _classCallCheck(this, GreaterThan);

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  _createClass(GreaterThan, [{
    key: 'link',
    value: function link($scope, element, attrs, ctrl) {
      var compareTo = attrs.greaterThan;

      $scope.$watch(attrs.greaterThan, function () {
        ctrl.$validate();
      });

      ctrl.$validators.greaterThan = function (modelValue) {
        var watchVal = $scope.$eval(compareTo);

        if (modelValue === undefined || watchVal === undefined) {
          return true;
        }

        return modelValue > watchVal;
      };
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory() {
      'ngInject';

      return new GreaterThan();
    }
  }]);

  return GreaterThan;
}();

exports.default = GreaterThan;


// WEBPACK FOOTER //
// ./common/directives/validation/greater-than.js